(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fecha-entrega"] && !Shopify.designMode) return;
  try {
    // Cuenta atrás hasta la hora de corte, en la hora de la tienda (Europe/Madrid), no en la del
  // navegador. Solo cambia el texto de la coletilla; el HTML que ve Google es el de siempre.
  // Al llegar al corte vuelve a pedir la ficha y cambia el bloque entero (día nuevo, sin coletilla).
  (function () {
    var ZONA = 'Europe/Madrid';
    function minutosMadrid() {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: ZONA, hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      var h = 0, m = 0;
      p.forEach(function (x) { if (x.type === 'hour') h = +x.value % 24; if (x.type === 'minute') m = +x.value; });
      return h * 60 + m;
    }
    function texto(nota, faltan) {
      var h = Math.floor(faltan / 60), m = faltan % 60;
      return (h > 0 ? nota.dataset.txtH : nota.dataset.txtM).replace('[h]', h).replace('[m]', m);
    }
    function recargar(bloque) {
      fetch(location.pathname + location.search, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-entrega-dia]');
          if (nuevo) bloque.replaceWith(nuevo);
        })
        .catch(function () {});
    }
    function pintar() {
      var nota = document.querySelector('.entrega-dia__nota[data-corte]');
      if (!nota) return;
      var bloque = nota.closest('[data-entrega-dia]');
      var faltan = (+nota.dataset.corte) * 60 - minutosMadrid();
      if (faltan <= 0) { recargar(bloque); return; }
      var aviso = (+nota.dataset.avisoHoras || 0) * 60;
      if (aviso > 0 && faltan <= aviso) {
        nota.textContent = texto(nota, faltan);
        nota.setAttribute('aria-live', 'polite');
      }
      var seg = new Date().getSeconds();
      setTimeout(pintar, (61 - seg) * 1000);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintar); else pintar();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filtros"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.add('js');
  document.querySelectorAll('[data-filtros]').forEach((det) => {
    const mq = window.matchMedia('(min-width: 900px)');
    const ajustar = () => { if (mq.matches) det.open = true; };
    ajustar(); mq.addEventListener('change', ajustar);
    const form = det.querySelector('[data-filtros-form]'); if (!form) return;
    let t;
    form.addEventListener('change', (e) => { clearTimeout(t); t = setTimeout(() => form.requestSubmit(), e.target.type === 'number' ? 700 : 150); });
    form.querySelectorAll('[data-filtro-mas]').forEach((b) => b.addEventListener('click', () => b.closest('.filtro').classList.add('is-expanded')));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const raiz = document.documentElement;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    raiz.classList.add('con-motion');
    const revelar = (el) => { el.classList.add('esta-dentro'); };
    const todos = () => document.querySelectorAll('[data-revelar]:not(.esta-dentro)');
    const quitarTodo = () => { todos().forEach(revelar); raiz.classList.remove('con-motion'); };
    // Seguro: a los 2,5 s se revela lo que ya esté dentro de la pantalla (si el observador fallara, la
    // red por scroll de abajo revela el resto al bajar). Nunca se apaga el movimiento entero por tiempo.
    const revelarVisibles = () => { const limite = window.innerHeight; todos().forEach((el) => { if (el.getBoundingClientRect().top < limite) revelar(el); }); };
    const seguro = setTimeout(revelarVisibles, 2500);

    const alturaPantalla = window.innerHeight;
    const seVeYa = (el) => el.getBoundingClientRect().top < alturaPantalla * 0.9;

    const marcar = () => {
      const secciones = [...document.querySelectorAll('main .shopify-section')];
      secciones.forEach((sec) => {
        if (sec.dataset.revelar !== undefined || sec.querySelector('[data-hero]')) return;
        const listas = sec.querySelectorAll('.rejilla > li, .destacada__lista > li, .mosaico__lista > li, .destacados__lista > li, .sellos > li, .familias__lista > li, .colecciones__lista > li, .resenas__lista > li, .posts__lista > li');
        if (listas.length > 1) {
          let n = 0;
          listas.forEach((li) => {
            if (li.dataset.revelar !== undefined || seVeYa(li)) return;
            li.dataset.revelar = '';
            li.style.setProperty('--retardo', Math.min(n, 7) * 45 + 'ms');
            n += 1;
          });
          // La cabecera de la sección (antetítulo + título) también entra, antes que sus tarjetas.
          const cab = sec.querySelector('.sec-head');
          if (cab && !seVeYa(cab)) cab.dataset.revelar = '';
        } else if (!seVeYa(sec)) {
          sec.dataset.revelar = '';
        }
      });
    };

    // Titulares por palabras: cada palabra en una máscara; se revelan con el ancestro [data-revelar] o al cargar.
    const partir = (el) => {
      if (el.dataset.partido) return;
      // Cada palabra recuerda si iba dentro de <em> (la palabra en cursiva del titular).
      const palabras = [];
      el.childNodes.forEach((n) => {
        const cursiva = n.nodeType === 1 && n.tagName === 'EM';
        n.textContent.trim().split(/\s+/).filter(Boolean).forEach((p) => palabras.push([p, cursiva]));
      });
      if (palabras.length < 1 || palabras.length > 24) return;
      el.textContent = '';
      palabras.forEach(([p, cursiva], i) => {
        const w = document.createElement('span'); w.className = 'w';
        const s = document.createElement('span'); s.style.setProperty('--i', Math.min(i, 12));
        if (cursiva) { const e = document.createElement('em'); e.textContent = p; s.appendChild(e); } else { s.textContent = p; }
        w.appendChild(s); el.appendChild(w);
        if (i < palabras.length - 1) el.appendChild(document.createTextNode(' '));
      });
      el.dataset.partido = '1';
      el.classList.add('split');
      if (!el.closest('[data-revelar]') && !el.closest('[data-hero]')) {
        void el.offsetWidth;
        setTimeout(() => el.classList.add('esta-dentro'), 40);
      }
    };
    const partirTodos = () => document.querySelectorAll('[data-split], .sec-head__t').forEach(partir);

    marcar();
    partirTodos();

    // Entrada del bloque principal: cuando las fuentes están (o a los 400 ms como mucho).
    const heroes = document.querySelectorAll('[data-hero]');
    if (heroes.length) {
      const listo = () => heroes.forEach((h) => h.classList.add('hero--listo'));
      Promise.race([document.fonts.ready, new Promise((r) => setTimeout(r, 400))]).then(() => setTimeout(listo, 30));
    }

    // Parallax suave (solo escritorio): la foto del bloque principal sube un poco al bajar.
    const flotantes = document.querySelectorAll('[data-parallax]');
    if (flotantes.length && window.matchMedia('(min-width: 900px)').matches) {
      let pedidoPx = false;
      const mover = () => {
        pedidoPx = false;
        const y = Math.min(window.scrollY, 700) * -0.07;
        flotantes.forEach((el) => { el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)'; });
      };
      window.addEventListener('scroll', () => { if (!pedidoPx) { pedidoPx = true; requestAnimationFrame(mover); } }, { passive: true });
    }

    if (!('IntersectionObserver' in window)) { clearTimeout(seguro); quitarTodo(); return; }

    // Al revelar uno, se revela también todo lo que queda por encima: si alguien salta al pie con
    // la tecla Fin o con un ancla, nada se queda invisible a su espalda.
    let orden = [];
    const reordenar = () => { orden = [...document.querySelectorAll('[data-revelar]')]; };
    const revelarHasta = (el) => {
      const i = orden.indexOf(el);
      if (i < 0) { revelar(el); return; }
      for (let k = 0; k <= i; k++) { if (!orden[k].classList.contains('esta-dentro')) { revelar(orden[k]); io.unobserve(orden[k]); } }
    };
    const io = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => { if (e.isIntersecting) { revelarHasta(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    reordenar();
    todos().forEach((el) => io.observe(el));

    // Segunda red, por scroll: si el salto deja en pantalla solo el pie (que no se anima), el
    // observador no dispara nada. Aquí se revela todo lo que ya ha quedado por encima del borde.
    let pedido = false;
    const repasar = () => {
      pedido = false;
      const limite = window.scrollY + window.innerHeight;
      let quedan = false;
      orden.forEach((el) => {
        if (el.classList.contains('esta-dentro')) return;
        if (el.getBoundingClientRect().top + window.scrollY < limite) { revelar(el); io.unobserve(el); }
        else quedan = true;
      });
      if (!quedan) window.removeEventListener('scroll', alScroll);
    };
    const alScroll = () => { if (!pedido) { pedido = true; requestAnimationFrame(repasar); } };
    window.addEventListener('scroll', alScroll, { passive: true });

    document.addEventListener('shopify:section:load', () => { marcar(); partirTodos(); reordenar(); todos().forEach((el) => io.observe(el)); window.addEventListener('scroll', alScroll, { passive: true }); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orden-y-chips"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-orden] select').forEach((s) => s.addEventListener('change', () => s.form.requestSubmit()));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Segunda foto de la tarjeta: se descarga la primera vez que el ratón entra en la tarjeta, no antes.
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', (e) => {
      const link = e.target.closest('.card__link');
      if (!link) return;
      const segunda = link.querySelector('.card__pic--2[hidden]');
      if (segunda) segunda.hidden = false;
    }, { passive: true });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["selector-idioma"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-idioma] select').forEach((s) => s.addEventListener('change', () => s.form.submit()));
  } catch(e) { console.error(e); }
})();

})();
